import React, { Component } from "react";
import PropTypes from "prop-types";
import getInitialData from "components/utility/api/GetInitialData";

class DataContainer extends Component {
	constructor() {
		super();
		this.state = {
			data: null
		};
	}

	componentDidMount() {
		if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
			const that = this;
			(async function () {
				const data = await getInitialData(that.props.data, null);
				that.setState({ data });
			})();
		}
	}

	render() {
		return React.cloneElement(this.props.children, {
			data: this.state.data || window[this.props.data] || null
		});
	}
}

DataContainer.propTypes = {
	data: PropTypes.string.isRequired,
	children: PropTypes.element.isRequired
};

export default DataContainer;
